/**
 * `@repo/client/data/community` — the votes on the curated roadmap and
 * "Sugerir uma função" (`D263`): route functions, the one query key and the
 * two mutations.
 *
 * ── ONLINE ONLY ─────────────────────────────────────────────────────────────
 * Neither write goes through the outbox (`D163`). Both are still safe to
 * resend: a vote is a PUT and its withdrawal a DELETE on the pair (account,
 * item), and a request carries the client's UUIDv7, minted once per form.
 */
import { COMMUNITY_ROUTES, featureRequestOutput, roadmapVoteOutput, roadmapVotePath, roadmapVotesOutput, } from "@repo/contract/community";
import { getJson, sendJson, } from "../core/request";
export const communityKeys = {
    all: ["community"],
    votes: () => ["community", "votes"],
};
/** `GET /me/roadmap/votes` — the caller's own votes, never a count. */
export function fetchRoadmapVotes(api, init) {
    return getJson(api, COMMUNITY_ROUTES.votes, roadmapVotesOutput, init);
}
/** `PUT` (`voted: true`) or `DELETE` (`voted: false`) one vote. */
export function setRoadmapVote(api, input) {
    return sendJson(api, input.voted ? "PUT" : "DELETE", roadmapVotePath(input.itemId), undefined, roadmapVoteOutput);
}
/** `POST /me/feature-requests` — 201 new, 200 for a resend of `input.id`. */
export function submitFeatureRequest(api, input) {
    return sendJson(api, "POST", COMMUNITY_ROUTES.featureRequests, input, featureRequestOutput);
}
/** The person's votes. Moves only when they vote, which invalidates it. */
export function roadmapVotesOptions(api) {
    return {
        queryFn: ({ signal }) => fetchRoadmapVotes(api, { signal }),
        queryKey: communityKeys.votes(),
        staleTime: 5 * 60_000,
    };
}
export function roadmapVoteMutation(api) {
    return {
        invalidates: [communityKeys.votes()],
        mutationFn: (input) => setRoadmapVote(api, input),
        mutationKey: ["community", "vote"],
    };
}
export function featureRequestMutation(api) {
    return {
        mutationFn: (input) => submitFeatureRequest(api, input),
        mutationKey: ["community", "request"],
    };
}
export { boardKeys, boardOptions, communityPostMutation, communityPostVoteMutation, fetchBoard, } from "./board";
// Clubs (`D277`–`D279`), on the same subpath: one more file, no new export
// map entry or test alias.
export { clubDetailOptions, clubDirectoryOptions, clubKeys, clubListOptions, clubMemberMutation, clubMessageActionMutation, clubMessageMutation, clubMessagesOptions, clubReactionMutation, clubRoundMutation, clubSettingsMutation, createClubMutation, fetchClubInvite, joinClubMutation, leaveClubMutation, } from "./clubs";
export { fetchGallery, galleryKeys, galleryOptions, offerToGalleryMutation, reportGalleryMutation, } from "./gallery";
export { ensureInviteMutation, fetchMyInvite, inviteKeys, myInviteOptions, redeemInvite, redeemInviteMutation, } from "./invite";
export { createPlanShareMutation, fetchMyPlanShares, fetchSharedPlan, importSharedPlanMutation, myPlanSharesOptions, planShareKeys, revokePlanShareMutation, sharedPlanOptions, } from "./plan-share";
//# sourceMappingURL=index.js.map